module.exports = __webpack_public_path__ + "img/assets.f8c1a3a6.svg";